import { Watch, checkBoxToString,  ChangeLogService, ChangeLogFilter, BaseTLTableComponent, AxiosResponse, tlISODateTimeToLocalNoSecondsString } from "../../../Infrastructure/CorBase/CoreBase";

	export default abstract class ChangeLogListBase extends BaseTLTableComponent {
		changeLogService: ChangeLogService = new ChangeLogService();

		isBusy = false;

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let filter: ChangeLogFilter = new ChangeLogFilter(this.$store.state.idTenant);
			return this.changeLogService.getAllByFilter(filter)
		}

		prepareItems(items: any[]) {
			for (var i = 0; i < items.length; i++) {
				items[i].whenChanged = tlISODateTimeToLocalNoSecondsString(items[i].whenChanged);
				items[i].mustBeConfirmedText = this.$t(checkBoxToString(items[i].mustBeConfirmed)).toString();
				items[i].isConfirmedText = this.$t(checkBoxToString(items[i].isConfirmed)).toString();
			}
			this.isBusy = false;
		}

		//zatím nepotrebujeme
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return this.fetchDataFromServer();
		}

		refreshItems(items: any[], refreshData: any[]) {
			return items;
		}

		//nastavení sloupcu tabulky
		setFields() {
			this.fields = [
				{ key: 'idObjectTypeNavigationName', label: this.$t('changeLog.fieldObject'), trans: 'changeLog.fieldObject', sortable: true, class: 'text-center', design: 'detail' },
				{ key: 'idChangeTypeNavigationName', label: this.$t('changeLog.fieldTypeChange'), trans: 'changeLog.fieldTypeChange', sortable: true,  class: 'text-center' },
				{ key: 'description', label: this.$t('changeLog.fieldName'), trans: 'changeLog.fieldName', sortable: true, class: 'text-center' },
				{ key: 'idWhoChangedNavigationLogin', label: this.$t('changeLog.fieldWho'), trans: 'changeLog.fieldWho', sortable: true,  class: 'text-center' },
				{ key: 'whenChanged', label: this.$t('changeLog.fieldWhen'), trans: 'changeLog.fieldWhen', sortable: true,  class: 'text-center' },
				{ key: 'mustBeConfirmedText', label: this.$t('changeLog.fieldAutorize'), trans: 'changeLog.fieldAutorize', sortable: true, class: 'text-center' },
				{ key: 'isConfirmedText', label: this.$t('changeLog.fieldApproved'), trans: 'changeLog.fieldApproved', sortable: true, class: 'text-center' },
				{ key: 'idWhoConfirmedNavigationLogin', label: this.$t('changeLog.fieldWhoApporove'), trans: 'changeLog.fieldWhoApporove', sortable: true, class: 'text-center' },
				{ key: 'actions', label: this.$t('changeLog.fieldActions'), trans: 'changeLog.fieldActions', class: 'text-right', thClass: 'lastColumnTable' }
			]
		};


		//filtry
		setfilters(value: any) {
			if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
				this.filters = [
					{ key: 'idObjectTypeNavigationName', label: this.$t('changeLog.filterObject'), trans: 'changeLog.filterObject', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage },
					{ key: 'idChangeTypeNavigationName', label: this.$t('changeLog.filterTypeChange'), trans: 'changeLog.filterTypeChange', selected: false, value: null, type: 'text' },
					{ key: 'description', label: this.$t('changeLog.filterName'), trans: 'changeLog.filterName', selected: false, value: null, type: 'text' },
					{ key: 'idWhoChangedNavigationLogin', label: this.$t('changeLog.filterWho'), trans: 'changeLog.filterWho', selected: false, value: null, type: 'text' },
					{ key: 'mustBeConfirmedText', label: this.$t('changeLog.filterAutorize'), trans: 'changeLog.filterAutorize', selected: true, value: 'Ano', type: 'text' },
					{ key: 'idWhoConfirmedNavigationLogin', label: this.$t('changeLog.filterWhoApporove'), trans: 'changeLog.filterWhoApporove', selected: false, value: null, type: 'text' },
					{ key: 'isConfirmedText', label: this.$t('changeLog.filterApproved'), trans: 'changeLog.filterApproved', selected: true, value: 'Ne', type: 'text' }
				]
			}
		}

		// VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
		loadFilters(value: any) { super.loadFilters(value); };
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); };		
		deleteClick(elementId: any) { super.deleteClick(elementId); };

		//@ts-ignore
		@Watch('$store.state.currentLanguage')
		changeFieldsAfterChangeLanguageD(value: boolean, oldValue: boolean) {
			this.setfilters(null);
		}
	};